import React from 'react';
import { useIntl } from 'react-intl';
import { useRouteMatch } from 'react-router-dom';
import { Form, Modal } from 'antd';

import { queryClient } from '@/Root';

import SubgroupForm from '../SubgroupForm';
import { useCreateSubGroup } from '@/core/domain/operational/SubGroups/SubGroups.hooks';

interface Props {
  visible: boolean;
  handleVisible: () => void;
}

const CreateSubgroupModal = ({ visible, handleVisible }: Props) => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const { groupId } = useRouteMatch<{ groupId: string }>().params;

  const mutation = useCreateSubGroup();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      const obj = {
        ...values,
        groupId,
      };

      await mutation.mutateAsync(obj);

      queryClient.invalidateQueries(['subgroups']);

      handleCancel();
    } catch {}
  };

  const handleCancel = () => {
    form.resetFields();

    handleVisible();
  };

  return (
    <Modal
      title={intl.formatMessage({ id: 'groups.subgroups.create' })}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={mutation.isLoading}
    >
      <SubgroupForm form={form} />
    </Modal>
  );
};

export default CreateSubgroupModal;
